(ns com.theplantscape.browser-utils.ensemble
  (:require [com.theplantscape.browser-utils.core :as c]))

(def biometric-auth c/biometric-auth)

(defn download-data-url [filename data-url]
  (c/download-data-url filename data-url))

(defn data-uri-svg
  ([data] (data-uri-svg "image/svg+xml" data))
  ([mimetype data] (c/data-uri-svg mimetype data)))

(defn register-gps-data-watch [position-fn error-fn]
  (c/register-gps-data-watch position-fn error-fn))

(defn store-set-item! [key val]
  (c/store-set-item! key val))

(defn store-get-item [key]
  (c/store-get-item key))

(defn store-remove-item! [key]
  (c/store-remove-item! key))

(defn redirect! [loc]
  (c/redirect! loc))

(defn open-in-new-tab [url]
  (c/open-in-new-tab url))

(defn to-js-array-buffer [text]
  (c/to-js-array-buffer text))

(defn from-js-array-buffer [text]
  (c/from-js-array-buffer text))

(defn web-auth-store-user [user]
  (c/web-auth-store-user user))

(defn web-auth-supported? []
  (c/web-auth-supported?))

(defn web-auth-create-credentials [public-key-fn]
  (c/web-auth-create-credentials public-key-fn))

(defn web-auth-get-credentials []
  (c/web-auth-get-credentials))
